import React from 'react'
import Header from '../_components/common/Header'
import Index from '../_components/SchoolManagement/Index'

const SchoolManagement = () => {
  return (
    <div className='page-main'>
        <Header name = {["School Management"]} />
        <Index />
    </div>
  )
}

export default SchoolManagement